<template>
    <div>
        <div class="box">
            <b-button @click="$router.push(`${$route.path}/new`)" class="level-item mb-3" type="is-primary">
                <b-icon icon="plus-circle" pack="fas" />
                <span>New {{ itemName }}</span>
            </b-button>

            <b-table
                narrowed
                bordered
                striped
                :sticky-header="stickyHead"
                :height="stickyHead ? '720px' : undefined"
                :data="items"
                :loading="isLoading"
                hoverable
                icon-pack="fas"
            >
                <b-table-column
                    v-for="(col, index) in columns"
                    :key="index"
                    :field="col.field"
                    :label="col.label"
                    :sortable="col.sortable"
                    v-slot="props"
                >
                    <template v-if="col.langFlags">
                        <b-tooltip label="English" :key="props.row[col.field]" v-if="props.row[col.field] == 'en'">
                            <img class="flag-img" src="/images/uk.png" />
                        </b-tooltip>
                        <b-tooltip label="Arabic" :key="props.row[col.field]" v-if="props.row[col.field] == 'ar'">
                            <img class="flag-img" src="/images/iq.png" />
                        </b-tooltip>
                        <b-tooltip label="Kurdish" :key="props.row[col.field]" v-if="props.row[col.field] == 'ku'">
                            <img class="flag-img" src="/images/krd.png" />
                        </b-tooltip>
                    </template>

                    <template v-else-if="col.formatDate">
                        {{ props.row[col.field] | formatDate }}
                    </template>
                    <template v-else-if="col.formatNumber">
                        {{ props.row[col.field] | formatNumber }}
                    </template>
                    <template v-else-if="col.mapToIcon">
                        <b-tooltip
                            :type="item.type"
                            :label="`${item.label ? item.label : props.row[col.field]}`"
                            v-for="(item, index) in col.mapToIcon"
                            :key="index"
                        >
                            <b-icon
                                v-if="item.value === props.row[col.field]"
                                :key="index"
                                :icon="item.icon"
                                :type="item.type"
                            />
                            <template v-else>
                                <template v-if="item.else">
                                    {{ props.row[col.field] }}
                                </template>
                            </template>
                        </b-tooltip>
                    </template>
                    <template v-else-if="col.image_preview">
                        <div class="img-preivew-container" v-if="props.row[col.field]">
                            <div class="list-img-preview">
                                <img :src="props.row[col.field].filename_small" />
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        {{ props.row[col.field] }}
                    </template>
                </b-table-column>

                <b-table-column label="Actions" width="135" v-slot="props">
                    <b-tooltip label="Edit">
                        <a @click="$router.push(`${$route.path}/${props.row.id}`)">
                            <b-icon icon="file-document-edit-outline"></b-icon>
                        </a>
                    </b-tooltip>
                    <b-tooltip label="Delete" type="is-danger">
                        <a @click="deleteItem(props.row.id, 'delete')">
                            <b-icon icon="delete" type="is-danger"></b-icon>
                        </a>
                    </b-tooltip>
                </b-table-column>

                <template slot="empty">
                    <section class="section">
                        <div class="content has-text-grey has-text-centered">
                            <p>
                                <b-icon icon="frown" pack="far" size="is-large"></b-icon>
                            </p>
                            <p>Nothing here.</p>
                        </div>
                    </section>
                </template>
            </b-table>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            itemName: "Partners",
            apiURI: "/partners",
            items: [],
            columns: [
                {
                    field: "id",
                    label: "ID",
                    width: "40",
                    numeric: true,
                },
                {
                    field: "link",
                    label: "Link",
                },
                {
                    field: "file",
                    label: "image",
                    image_preview: true,
                },
                {
                    field: "created_at",
                    label: "Created Date",
                    centered: true,
                    sortable: true,
                    formatDate: true,
                },
            ],
            isLoading: true,
            stickyHead: false,
        };
    },
    methods: {
        async init() {
            this.loadTable();
        },
        onPageChange(page) {
            this.page = page;
            this.loadTable();
        },
        onSort(field, order) {
            this.sortField = field;
            this.sortOrder = order;
            this.loadTable();
        },
        async loadTable() {
            this.isLoading = true;
            let params = [
                `page=${this.page}`,
                `sort=${this.sortField}`,
                `order=${this.sortOrder}`,
                this.searchQuery ? `search=${this.searchQuery}` : "",
            ].join("&");
            try {
                let res = await this.$http.get(this.apiURI + "?" + params);
                this.items = res.data;
            } catch (error) {
                this.items = [];
                this.total = 0;
                this.page = 1;
            }
            this.isLoading = false;
        },
        deleteItem(id, action = "delete") {
            this.$buefy.dialog.confirm({
                title: action,
                message: `Are you sure you want to <b>${action}</b> this partner?`,
                confirmText: action,
                type: "is-danger",
                hasIcon: true,
                onConfirm: () => {
                    this.isLoading = true;
                    // Send request to server
                    this.$http
                        .delete(`${this.apiURI}/${id}`)
                        .then(() => {
                            this.$buefy.toast.open(`Partner ${action}!`, "is-success");
                            this.loadTable();
                        })
                        .catch(() => {
                            this.$buefy.toast.open({
                                duration: 5000,
                                message: `There were something wrong`,
                                position: "is-bottom",
                                type: "is-danger",
                            });
                            this.isLoading = false;
                        });
                },
            });
        },
        search() {
            if (this.searchQuery == "") {
                this.searchStr = "";
            } else {
                this.searchStr = "&" + `search=${this.searchQuery}`;
            }
            this.page = 1;
            this.loadTable();
        },
    },
    mounted() {
        this.init();
    },
    beforeDestroy() {},
};
</script>

<style>
.list-img-preview {
    margin-inline: 4px;
    overflow: hidden;
    position: relative;
}
.list-img-preview img {
    object-fit: cover;
    width: 90px;
    max-width: 90px;
    height: 60px;
    max-height: 60px;
}
.list-img-preview .fade {
    background: rgba(0, 0, 0, 0.5);
    width: 90px;
    max-width: 90px;
    height: 60px;
    max-height: 60px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 4;
    color: white;
    text-align: center;
    padding-top: 20px;
}
.img-preivew-container {
    white-space: nowrap;
    display: flex;
}
</style>